import React from "react";

import { CrossIcon, PlusIcon, X } from "lucide-react";
import { StandardTooltip } from "../../../../shared/StandardTooltip/StandardTooltip";
import { BoldText, SmallNormalText } from "../../../../../utils/typographyUtils";
import { DetailViewAccordion } from "../DetailViewAccordion/DetailViewAccordion";
import { OkrAccordion } from "../OkrAccordion/OkrAccordion";

export const UnpublishedPlanObjectiveAccordionItem = ({
  objective,
  callBack,
  isPlanPublished,
  businessPlanId,
  isLastObjective,
  ref,
  onHeaderClick,
  isExpanded,
  showRemovePracticePopup,
  showConfirmationButtons,
  setShowConfirmationButtons,
  setShowRemovePracticePopup,
  dragHandleProps,
  closeAllAccordions,
  showActions,
}) => {
  return (
    <div
      ref={ref}
      className="border cs-br-8 my-3 unpublished-plan-objective-accordion-item"
    >
      <div
        onClick={onHeaderClick}
        className={`objective-accordion-header cursor-pointer ${isExpanded ? "border-bottom" : ""} d-flex flex-column p-3 p-md-0 flex-md-row align-items-md-center justify-content-between`}
      >
        <div className="d-flex align-items-center p-md-3 mb-3 mb-md-0">
          <div {...dragHandleProps}>
            <img
              src="/assets/images/draggable.svg"
              className="cursor-grab me-2"
            />
          </div>
          <div onClick={onHeaderClick} className="d-flex align-items-center">
            <StandardTooltip tooltTipContent={"X-Ray Recommendation"}>
              <img src="/assets/images/practice.svg" className="me-2" />
            </StandardTooltip>
            <BoldText classNames={"cursor-pointer"}>
              {objective.practiceName}
            </BoldText>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center px-3">
            {isLastObjective ? null : (
              <div
                onClick={(e) => {
                  // e.stopPropagation();
                  // setShowRemovePracticePopup({
                  //   show: true,
                  //   id: objective.businessPlanObjectiveId,
                  // });
                }}
                className="me-3 border rounded d-flex align-items-center bg-white rounded remove-objective-button cursor-pointer"
              >
                <SmallNormalText classNames={"me-2"}>
                  <X height={14} />
                  Not a focus area? Remove
                </SmallNormalText>
              </div>
            )}
            <img
              onClick={(e) => {
                e.stopPropagation();
                onHeaderClick();
              }}
              className="cursor-pointer"
              src={`/assets/images/${isExpanded ? "up-arrow.svg" : "down-arrow.svg"}`}
            />
          </div>
        </div>
      </div>
      <div
        className={`unpublished-plan-objective-accordion-body ${isExpanded ? "open" : ""}`}
      >
        <DetailViewAccordion
          objectiveDetails={objective}
          closeAllAccordions={closeAllAccordions}          
        />
        <OkrAccordion
          callBack={callBack}
          businessPlanId={businessPlanId}
          isPlanPublished={isPlanPublished}
          objective={objective}
          showConfirmationButtons={{}}
          closeAllAccordions={closeAllAccordions}
          showActions={showActions}
        />
      </div>
    </div>
  );
};
